/* eslint-disable no-console */
import React, { useState } from 'react';
import { useLabels } from 'wsm-common-data';
import { useGoogleApiSession } from '../hooks/useGoogleApiSession';
import { useFetchLocationSuggestions } from '../hooks/useFetchLocationSuggestions';
import AutocompleteSearch from '../components/AutocompleteSearch';
import SearchResultCount from '../components/SearchResultCount';
import ListAllLocationsLink from '../components/ListAllLocationsLink';
import MapToggleButton from '../components/MapToggleButton';

import '../global-sass/main.scss';

const Widget = () => {
	const labels = useLabels();
	// eslint-disable-next-line no-unused-vars
	const [inputString, setInputString] = useState('');
	const [selectedPlaceId, setSelectedPlaceId] = useState(null);
	const [hasLocations, setHasLocations] = useState(false);
	const { isApiReady, sessionToken, resetSession } =
		useGoogleApiSession(inputString);
	const { suggestions } = useFetchLocationSuggestions(
		inputString,
		sessionToken,
		isApiReady
	);
	return (
		<>
			<div className="row">
				<h2 className="col-xs-6 col-sm-4 text-left text-body">
					{labels.get('LOCATIONS')}
				</h2>
				<div className="col-xs-6 col-sm-4 col-sm-push-4 text-right mt-5">
					<ListAllLocationsLink />
				</div>
				<div className="col-xs-12 col-sm-4 col-sm-pull-4 mt-md-5 mt-2">
					<AutocompleteSearch
						suggestions={suggestions}
						inputString={inputString}
						setInputString={setInputString}
						setSelectedPlaceId={setSelectedPlaceId}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-xs-12 col-md-4 col-md-offset-4 text-center">
					<SearchResultCount
						isApiReady={isApiReady}
						sessionToken={sessionToken}
						resetSession={resetSession}
						selectedPlaceId={selectedPlaceId}
						onLocationStatusChange={setHasLocations}
					/>
				</div>
				{hasLocations && (
					<div className="col-xs-12 col-md-4 hidden-xs hidden-sm text-right">
						<MapToggleButton />
					</div>
				)}
			</div>
		</>
	);
};

export default Widget;
